<template>
  <div class="q-composite-container">

  </div>
</template>

<script>
  import listMixin from '../../mixins/listMixin'

  export default {
    name: "QList",

    mixins: [listMixin],
    props: {
      structureKey: {required: true, type: String}
    },

    data() {
      return {
        deleteDialog: false,

        compositeRules: undefined,
        compositeFormStructure: undefined,
        detailDialog: false,
        currentModel: undefined,

        rangeModel: {}
      }
    },

    computed: {},

    watch: {},

    mounted() {
    },

    methods: {}
  }

</script>

<style scoped>
  .q-composite-container {
    background-color: #fff;
    border: 1px solid #cfdbe2;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
    border-radius: 4px;
    margin: 1px;
    padding: 15px;
  }

  .q-toolbar {
    margin-bottom: 20px;
  }

  .q-composite-list {

    margin: 0;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>